//
// Example Exports for simple functions:
// check it: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/export
console.log('smoothscroll');

function smooth(){
	console.log('hi')
}

export {smooth};




// Call smooth(); in the doc where it's imported later:
// smooth();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/example-simple-function-export.js